import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/components/pages/Login'
import EnterpriseList from '@/components/pages/EnterpriseList'
import SectionList from '@/components/pages/SectionList'
import UserList from '@/components/pages/UserList'
import StockDataSet from '@/components/pages/StockDataSet'
import EnterpriseEdit from '@/components/pages/EnterpriseEdit'
import SectionEdit from '@/components/pages/SectionEdit'
import UserEdit from '@/components/pages/UserEdit'
import InventoryInfoList from '@/components/pages/InventoryInfoList'
import InventoryTargetFileList from '@/components/pages/InventoryTargetFileList'
import StockFileUpload from '@/components/pages/StockFileUpload'
import ErrorPage from '@/components/pages/Error'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    { // ログイン画面
      path: '/login',
      name: 'login',
      component: Login,
      props: true
    },
    { // ログイン画面
      path: '/',
      name: 'login',
      component: Login,
      props: true
    },
    // ==================================
    // マスタ設定
    // ==================================
    { // 企業一覧
      path: '/enterpriseList',
      name: 'enterprise-list',
      component: EnterpriseList,
      props: true
    },
    { // 拠点一覧
      path: '/sectionList',
      name: 'section-list',
      component: SectionList,
      props: true
    },
    { // ユーザ一覧
      path: '/userList',
      name: 'user-list',
      component: UserList,
      props: true
    },
    { // CSV取込設定
      path: '/stockDataSet',
      name: 'stock-data-set',
      component: StockDataSet
    },
    { // 企業情報設定
      path: '/enterpriseEdit',
      name: 'enterprise-edit-new',
      component: EnterpriseEdit,
      props: true
    },
    { // 企業情報設定
      path: '/enterpriseEdit/:enterpriseCode',
      name: 'enterprise-edit',
      component: EnterpriseEdit,
      props: true
    },
    { // 拠点情報設定
      path: '/sectionEdit',
      name: 'section-edit-new',
      component: SectionEdit,
      props: true
    },
    { // 拠点情報設定
      path: '/sectionEdit/:enterpriseCode/:sectionCode',
      name: 'section-edit',
      component: SectionEdit,
      props: true
    },
    { // ユーザ情報設定
      path: '/userEdit',
      name: 'user-edit-new',
      component: UserEdit,
      props: true
    },
    { // ユーザ情報設定
      path: '/userEdit/:enterpriseCode/:sectionCode/:userId',
      name: 'user-edit',
      component: UserEdit,
      props: true
    },
    // ==================================
    // 棚卸管理
    // ==================================
    { // 棚卸情報一覧
      path: '/inventoryInfoList',
      name: 'inventory-info-list',
      component: InventoryInfoList
    },
    // ==================================
    // 帳簿管理
    // ==================================
    { // 棚卸対象ファイル一覧
      path: '/inventoryTargetFileList',
      name: 'inventory-target-file-list',
      component: InventoryTargetFileList
    },
    { // 棚卸対象ファイルアップロード
      path: '/stockFileUpload',
      name: 'stock-file-upload',
      component: StockFileUpload
    },
    // ==================================
    // 権限エラー
    // ==================================
    { // 403
      path: '/errPage',
      name: 'error',
      component: ErrorPage,
      props: true
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js